import $http from '@/libs/axios'
import FormsService from '@/services/forms-service'

class StatisticsAPIs {
  static async customerPageStatistics() {
    return (await $http.get('/marketing/statistics/customers-page')).data
  }

  static async generalStatistics(query: any) {
    const queryString = FormsService.prepareQueryString(query, true)
    return (await $http.get(`/marketing/statistics?${queryString}`)).data
  }

  static async itemsInsight(query: any) {
    const queryString = FormsService.prepareQueryString(query, true)
    return (await $http.get(`/marketing/statistics/items-insight?${queryString}`)).data
  }

  static async addCustomClientGroup(body: any) {
    return (await $http.post('/marketing/statistics/add-custom-customer-group', body)).data
  }

  static async deleteCustomClientGroup(id: any) {
    return (await $http.post(`/marketing/statistics/delete-custom-customer-group/${id}`)).data
  }

  static async editCustomClientGroup(body: any) {
    return (await $http.post('/marketing/statistics/add-custom-customer-group', body)).data
  }
}

export default StatisticsAPIs
